import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// css基础样式重置
import '@/assets/css/reset.css'
import '@/assets/css/iconfont.css'

// element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
Vue.use(ElementUI)

// vue-awesome-swiper
import Swiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(Swiper)

// 全局组件
import binnerOneItem from '@/components/binnerItem'
Vue.component('binnerOneItem', binnerOneItem)
import titleItem from '@/components/zh-en-titleItem'
Vue.component('titleItem', titleItem)


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')